import React, {useState} from "react";
import logo from "../logo-no-background.png";
import "../CSS_folder/Header.css";

function Header() {

   const [isReloading, setReloading] = useState(false);

   const reloadPage = () => {
     if (!isReloading) {
       setReloading(true);
       window.location.reload();
     }
   };
  return (
    <div id="header" className="headerContainer">
      <div className="headerSubcontainer">
        <div className="iconLeft">
          <img
            className="headerIcon"
            src={logo}
            alt="Logo"
            onClick={reloadPage}
          />
        </div>
        <div className="navbarRight">
          <a href="#about">
            <div className="navbarRightItem">About</div>
          </a>
          <a href="#skills">
            <div className="navbarRightItem">Skills</div>
          </a>
          <a href="#project">
            <div className="navbarRightItem">Projects</div>
          </a>
          <a href="#contact">
            <div className="navbarRightItem">Contact</div>
          </a>
        </div>
      </div>
    </div>
  );
}

export default Header;
